import queryString from 'querystring';
function append(base, id, partnerId, date) {
    const params = base;
    params.tracking = String(id);
    params.trackingdate = date;
    params.lasttracking = String(id);
    if (partnerId) {
        params.firstpartner = partnerId;
        params.lastpartner = partnerId;
    }
    params.lasttrackingdate = date;
    params.version = '1_1';
    return queryString.stringify(params);
}
function update(base, id, partnerId, date) {
    const params = base;
    params.lasttracking = String(id);
    params.lasttrackingdate = date;
    if (partnerId)
        params.lastpartner = partnerId;
    params.trackingdate = date;
    return queryString.stringify(params);
}
export function computeTrackingWithQuery(query, id, cookie) {
    const { ptnrid, gclid } = query;
    const partnerId = gclid || ptnrid;
    const date = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
    const params = cookie && cookie !== 'undefined' ? queryString.parse(cookie) : {};
    return cookie && params.tracking ? update(params, id, partnerId, date) : append(params, id, partnerId, date);
}
// Track
function compute(watchContext, id, cookie) {
    const { req } = watchContext;
    const { query } = req;
    return computeTrackingWithQuery(query, id, cookie);
}
export default { compute };
